import { UserBudgetReadModel, UsersCurrentApi } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { CurrentUserApiService } from "../ApiServices/CurrrentUserApiService";
import GenericService from "../GenericService";

export class CurrentUserService extends GenericService<UsersCurrentApi, CurrentUserApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, UsersCurrentApi, CurrentUserApiService);
  }

  public async ensureHasBudget(): Promise<void> {
    const response: UserBudgetReadModel = await this.apiService.usersCurrentBudget();
    this.storeContext.budgetStore.setBudgetInfo(response);
  }

  public async ensureUserPermissions(): Promise<void> {
    this.storeContext.permissionStore.isLoadingPermissions = true;

    const response = await this.apiService.usersCurrentGetPermissions();
    if (!response) {
      console.error("Failed to fetch user account permissions.");
    }

    this.storeContext.permissionStore.setUserPermissions(response);

    this.storeContext.permissionStore.isLoadingPermissions = false;
  }
}
